import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslocoPipe, TranslocoService, provideTranslocoScope } from '@jsverse/transloco';
import { AppMaterialModule } from '../../../../app-material.module';
import { COMING_SOON_TRAFFIC_SOURCE_CONFIG, ComingSoonTrafficSource } from './coming-soon-traffic-source';

export const COMING_SOON_DIALOG_PANEL_CLASS = 'coming-soon-dialog-panel';

export interface ComingSoonDialogData {
    source: ComingSoonTrafficSource;
}

export function openComingSoonDialog(
    dialog: MatDialog,
    source: ComingSoonTrafficSource,
): MatDialogRef<ComingSoonDialogComponent> {
    return dialog.open(ComingSoonDialogComponent, {
        data: { source },
        panelClass: COMING_SOON_DIALOG_PANEL_CLASS,
        autoFocus: false,
        restoreFocus: true,
        width: 'min(520px, calc(100vw - 32px))',
    });
}

export function tryOpenComingSoonForManagementAdsNetwork(
    dialog: MatDialog,
    network: string,
    metaAdsEnabled: boolean,
): boolean {
    if (network === 'tiktok') {
        openComingSoonDialog(dialog, 'tiktok');
        return true;
    }
    if (network === 'mgid') {
        openComingSoonDialog(dialog, 'mgid');
        return true;
    }
    if (network === 'revcontent') {
        openComingSoonDialog(dialog, 'revcontent');
        return true;
    }
    if (network === 'meta' && !metaAdsEnabled) {
        openComingSoonDialog(dialog, 'meta');
        return true;
    }
    return false;
}

@Component({
    selector: 'app-coming-soon-dialog',
    standalone: true,
    imports: [CommonModule, AppMaterialModule, TranslocoPipe],
    providers: [...provideTranslocoScope('dialogs')],
    templateUrl: './coming-soon-dialog.component.html',
    styleUrl: './coming-soon-dialog.component.scss',
})
export class ComingSoonDialogComponent {
    readonly logoPath: string;
    readonly logoAlt: string;
    readonly titleId: string;
    readonly translationParams: { trafficSource: string };

    constructor(
        private readonly dialogRef: MatDialogRef<ComingSoonDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: ComingSoonDialogData,
        transloco: TranslocoService,
    ) {
        const config = COMING_SOON_TRAFFIC_SOURCE_CONFIG[data.source];
        this.logoPath = config.logoPath;
        this.logoAlt = config.logoAlt;
        this.titleId = `coming-soon-dialog-title-${data.source}`;
        this.translationParams = {
            trafficSource: transloco.translate(config.displayNameKey),
        };
    }

    close(): void {
        this.dialogRef.close();
    }
}
